<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="config-box">
        <el-row :gutter="20">
          <el-form
            ref="form"
            :model="form"
            class="form custom-form"
            label-position="top"
          >
            <div class="people-info-box">
              <div class="info-box">
                <el-image :src="headerImage" class="header-image"></el-image>
                <div class="info-box-right">
                  <div class="info-name">{{ userInfo.username }}</div>
                  <div class="info-phone">手机号码: {{ userInfo.phone }}</div>
                </div>
              </div>
            </div>
            <el-col :span="12">
              <el-form-item label="所属部门:">
                <el-input
                  v-model="userInfo.deptName"
                  readonly
                  style="width: 100%"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="岗位标签:">
                <el-input
                  v-model="userType"
                  readonly
                  style="width: 100%"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="系统角色:">
                <el-button
                  type="primary"
                  v-for="item in userInfo.roles"
                  :key="item.roleId"
                  >{{ item.roleName }}</el-button
                >
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
    <!--    <template v-slot:footer>-->
    <!--      <el-button type="default" @click.stop="handleCancel()">取消</el-button>-->
    <!--      <el-button-->
    <!--        type="primary"-->
    <!--        @click.stop="submitForm()"-->
    <!--        :loading="dialogObj.btnLoading"-->
    <!--        >确认</el-button-->
    <!--      >-->
    <!--    </template>-->
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validateIdAccount } from "@/utils/validate";
import { updatePwd } from "@/Layout/api";
import { getUserData } from "@/views/commonApi";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "UpdatePassword",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "个人信息",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.isDisabled = false;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      // 账号配置
      form: {
        deptName: "综合部/物业办公室",
        label: "调度员",
      },
      headerImage: require("@/assets/imgs/default-photo.png"),
      username: localStorage.getItem("username"),
      phone: localStorage.getItem("phone"),
      deptName: localStorage.getItem("deptName"),
      userInfo: {},
    };
  },
  computed: {
    userType: function () {
      return getLocalLabel("jobLabel", this.userInfo.userType);
    },
  },
  mounted() {},
  methods: {
    getLocalLabel,
    init() {
      this.getUserInfo();
      this.dialogObj.show = true;
    },
    getUserInfo() {
      getUserData().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.config-box {
  .people-info-box {
    padding: 0 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .info-box {
      width: 100%;
      height: 0.7rem;
      background-color: #f7fbff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      padding-left: 0.2rem;
      box-sizing: border-box;
      .info-box-right {
        padding-left: 0.2rem;
        .info-name {
          font-size: 0.14rem;
          color: #434343;
        }
        .info-phone {
          font-size: 0.12rem;
          color: #8c8c8c;
          padding-top: 0.1rem;
        }
      }
    }
    .header-image {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }
  }
}
</style>
